import { Link, useLocation } from 'react-router-dom';
import { useNotifStore } from '@/stores/notifications';

export function MobileNav() {
  const location = useLocation();
  const { unreadCount } = useNotifStore();

  const items = [
    { to: '/feed', label: 'Feed', icon: '\ud83d\udcf0' },
    { to: '/friends', label: 'Friends', icon: '\ud83d\udc65' },
    { to: '/messages', label: 'Chat', icon: '\ud83d\udcac' },
    { to: '/notifications', label: 'Alerts', icon: '\ud83d\udd14', badge: unreadCount },
    { to: '/groups', label: 'Groups', icon: '\ud83c\udfe0\ufe0f' },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-sand-300 safe-area-bottom">
      <div className="flex justify-around items-center h-12">
        {items.map(({ to, label, icon, badge }) => {
          const active = location.pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              className={`flex flex-col items-center justify-center flex-1 h-full relative transition-colors ${
                active ? 'text-vibe-500' : 'text-sand-500'
              }`}
            >
              <span className="text-lg leading-none">{icon}</span>
              <span className="text-[9px] font-semibold mt-0.5">{label}</span>
              {badge && badge > 0 ? (
                <span className="absolute top-1 right-1/4 bg-red-500 text-white text-[8px] font-bold rounded-full min-w-[14px] h-[14px] flex items-center justify-center px-0.5">
                  {badge > 99 ? '99+' : badge}
                </span>
              ) : null}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
